import React from 'react';

export const PlusIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25001 11.25V6.75H0.750008V5.25H5.25001V0.75H6.75001V5.25H11.25V6.75H6.75001V11.25H5.25001Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
